import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames/bind';
import { scrollToElement } from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { resetSflToCartSuccess } from '../../actions/SaveForLaterAction';
import * as styles from './SavedItemsProductCartridge.css';

const cx = classNames.bind(styles);

export class SavedItemAddToCartMessage extends Component {
    static propTypes = {
        sflActionStatus: PropTypes.objectOf(PropTypes.object),
        actions: PropTypes.objectOf(PropTypes.object).isRequired,
    };

    static defaultProps = {
        sflActionStatus: {},
    };

    constructor() {
        super();
        this.closeSuccessMessage = this.closeSuccessMessage.bind(this);
    }

    componentDidUpdate() {
        /* istanbul ignore else */
        if (!isEmpty(this.props.sflActionStatus.errorMessage) && this.addToCartWarning) {
            scrollToElement(this.addToCartWarning);
        }
    }

    closeSuccessMessage() {
        this.props.actions.resetSflToCartSuccess();
    }

    render() {
        const {
            isMoveToCartSuccess,
            isMoveToSFLSuccess,
            errorMessage,
        } = this.props.sflActionStatus;
        return (
            <div className={`${cx('savedItemAddtoCartContent')} ${dt(['py-0'])}`}>
                {isMoveToCartSuccess && (
                    <MessageBox
                        type="success"
                        level="section"
                        title="Item moved to cart"
                        automationId="at-add-to-cart-suceess-msg"
                        className={`${cx('addToCartSuccessMsg')} ${dt([
                            'smOnly:mt-4',
                            'lg:mt-2',
                            'mb-6',
                        ])}`}
                        hasClose
                        onClose={this.closeSuccessMessage}
                    />
                )}
                {!isMoveToCartSuccess && !isMoveToSFLSuccess && !isEmpty(errorMessage) && (
                    <div
                        ref={(input) => {
                            this.addToCartWarning = input;
                        }}
                    >
                        <MessageBox
                            type="warning"
                            level="section"
                            title={errorMessage}
                            automationId="at-add-to-cart-warning-msg"
                            className={`${cx('addToCartSuccessMsg')} ${dt([
                                'smOnly:mt-4',
                                'lg:mt-4',
                                'mb-6',
                            ])}`}
                            hasClose
                            onClose={this.closeSuccessMessage}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ sflActionStatus }) => ({
    sflActionStatus,
});

export const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ resetSflToCartSuccess }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedItemAddToCartMessage);
